export const REGISTER_REQUESTING = 'REGISTER_REQUESTING'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_ERROR = 'REGISTER_ERROR'
export const REGISTER_EXISTING = 'REGISTER_EXISTING'
export const REGISTER_URL = '/api/v1/users'


// WEBPACK FOOTER //
// ./src/views/Pages/Register/constants.js